<!--
 * @Author: Lemon C
 * @Date: 2024-04-29 09:30:41
 * @LastEditTime: 2024-12-05 11:21:22
-->
<template>
    <div class="sup-docs-title">
        <span class="docs-title-name">{{ docs_api_data.name }}</span>
        <span class="last-update-time" v-if="last_update_time_computed.length">{{ last_update_time_computed }}</span>
        <span class="docs-title-dis" v-if="docs_api_data.description && docs_api_data.description.length">{{ docs_api_data.description }}</span>
        <div class="docs-title-mark-box" v-if="docs_api_data.remark && docs_api_data.remark.length">
            <el-icon><Warning /></el-icon>
            <span class="mark-tip">说明：</span>
            <span class="mark-text">
                {{ docs_api_data.remark }}
            </span>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { computed } from 'vue';
import { formatTime } from '@/utils/generalMethods';

const props = defineProps({
    docs_api_data: Object,
});

const last_update_time_computed = computed(() => {
    let timeStr = '';
    if (props.docs_api_data.creationTime && props.docs_api_data.creationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(props.docs_api_data.creationTime);
    }
    if (props.docs_api_data.lastModificationTime && props.docs_api_data.lastModificationTime.length > 0) {
        timeStr = '最后更新于 ' + formatTime(props.docs_api_data.lastModificationTime);
    }
    return timeStr;
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-title {
    position: relative;
    text-align: left;
    display: flex;
    flex-direction: column;

    .docs-title-name {
        position: relative;
        height: 38px;
        color: var(--color-main-text-primary);
        font-size: 30px;
        font-weight: 600;
        line-height: 38px;
    }
    .last-update-time {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 5px;
        color: var(--color-main-text-secondary);
        font-size: 14px;
        font-variant: tabular-nums;
        line-height: 1.66667;
    }

    .docs-title-dis {
        position: relative;
        margin-top: 25px;
        min-height: 27px;
        font-weight: 400;
        font-size: 18px;
        color: var(--color-main-text-primary);
        line-height: 27px;
    }

    .docs-title-mark-box {
        position: relative;
        width: 100%;
        margin-top: 25px;
        background: var(--color-main-doc-remark-bg);
        border-radius: 4px;
        padding: 23px 25px 25px 25px;
        box-sizing: border-box;
        display: flex;

        i {
            position: relative;
            margin-top: 0.5em;
            color: var(--color-main-text-brand);
            font-size: 18px;
            line-height: 35px;
            flex-shrink: 0;
        }

        .mark-tip {
            position: relative;
            margin-left: 8px;
            width: 60px;
            font-weight: bold;
            font-size: 16px;
            color: var(--color-main-text-brand);
            line-height: 35px;
            flex-shrink: 0;
        }

        .mark-text {
            position: relative;
            font-size: 16px;
            color: var(--color-main-text-primary);
            line-height: 35px;
        }
    }
}
</style>
